.time {
  display: none;

  @media (--lg) {
    display: block;
  }
}

